import { lazy } from 'react';

import { PositionGroups } from './pages/PositionGroups/index.ts';

const AnalogProducts = {
  Advertisements: lazy(() => import('./pages/Advertisements/index.tsx')),
  AdvertisementsEdit: lazy(() => import('./pages/Advertisements/Edit/index.tsx')),
  AdvertisingSpaces: lazy(() => import('./pages/AdvertisingSpaces/index.tsx')),
  BranchClusters: lazy(() => import('./pages/BranchClusters/index.tsx')),
  BranchCountFactors: lazy(() => import('./pages/BranchCountFactors/index.tsx')),
  Dispatches: lazy(() => import('./pages/Dispatches/index.tsx')),
  Layout: lazy(() => import('./components/Layout.tsx')),
  MonthlyFactors: lazy(() => import('./pages/MonthlyFactors/index.tsx')),
  PositionGroups,
};

export default AnalogProducts;
